

















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Mutation, Action } from "vuex-class";

import { IUser, IUserLanguageData } from "@/models/interfaces/session";

import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";
import DataProvider from "@/utils/helpers/DataProvider";

import amplitude from "amplitude-js";
import { UserLanguage } from "@/models/types/session";

@Component({
  components: {
    Spinner
  }
})
export default class AuthCheckView extends Vue {
  @Action("session/fetchUser")
  public fetchUser!: () => Promise<IUser>;

  @Action("session/userLogout")
  public logout!: () => void;

  @Action("session/fetchUserLanguages")
  public fetchUserLanguages!: () => IUserLanguageData;

  @Mutation("session/setUserId")
  private setUserId!: (userId: string) => void;

  @Mutation("session/setUserAccessToken")
  private setUserAccessToken!: (accessToken: string) => void;

  get urlParams() {
    const urlParams = this.$route.query;
    const token = urlParams.t || localStorage.getItem("token");
    const redirect = urlParams.redirect || "/home";
    return { token, redirect };
  }

  private getSupportLanguage(name: UserLanguage) {
    const english = ["gb", "us"];
    return english.includes(name) ? "en" : name;
  }

  public mounted() {
    const { token, redirect } = this.urlParams;
    const bearerToken = `Bearer ${token}`;

    if (token) {
      DataProvider.setDefaultHeader("Authorization", bearerToken);

      this.fetchUser()
        .then(async response => {
          localStorage.setItem("token", token as string);
          this.setUserAccessToken(bearerToken);
          this.setUserId(response.userId);

          const { supportLanguage } = await this.fetchUserLanguages();
          this.$root.$i18n.locale = this.getSupportLanguage(supportLanguage);

          amplitude
            .getInstance()
            .init(
              process.env.VUE_APP_AMPLITUDE_API_KEY.toString(),
              response.userId,
              {
                userId: response.userId,
                domain: window.location.hostname,
                // eslint-disable-next-line no-console
                onError: () =>
                  console.error(
                    "Littlebridge Teacher Dashboard Amplitude Error"
                  )
              }
            );

          // Filtering existing query. If we have needed query in the URL,
          // we delete redirect and t and keep needed:
          const { t, redirect = "/home", ...query } = this.$route.query;
          this.$router.push({ path: redirect as string, query });
        })
        .catch((e: Error) => {
          this.logout();
        });
    } else {
      this.logout();
    }
  }
}
